module.exports = __webpack_public_path__ + "img/25_jbt8011_2-1999.prt.3e8095ce.jpg";